import { render, staticRenderFns } from "./AppDialogDefault.vue?vue&type=template&id=bb004638&scoped=true"
import script from "./AppDialogDefault.vue?vue&type=script&lang=js"
export * from "./AppDialogDefault.vue?vue&type=script&lang=js"
import style0 from "./AppDialogDefault.vue?vue&type=style&index=0&id=bb004638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb004638",
  null
  
)

export default component.exports